import { moneefloApi } from "./client";

/**
 * "Send Daily Rates" on the corporate leads page, answered by the new
 * backend. Xano's send_daily_rates took a branch and a list of
 * entity_table ids and BCC'd everyone on one message; here the API lists
 * the leads itself and sends one message per lead.
 */

export type DailyRateRow = {
  currency: string;
  buy: number;
  sell: number;
  card: number;
};

export type DailyRateRecipient = {
  id: string;
  name: string;
  email: string | null;
  status: string;
  city: string | null;
};

export type DailyRatesDraft = {
  /** yyyy-mm-dd, today in India. */
  date: string;
  /** The last sheet sent by this organization, or the default currencies. */
  rates: DailyRateRow[];
  lastSentAt: string | null;
  lastNote: string | null;
  recipients: DailyRateRecipient[];
  withEmail: number;
};

export type SendDailyRatesResult = {
  date: string;
  sent: number;
  skipped: { id: string; name: string; reason: string }[];
};

export async function getDailyRatesDraft(): Promise<DailyRatesDraft> {
  const { data } = await moneefloApi.get<DailyRatesDraft>("/daily-rates/draft");
  return data;
}

export async function sendDailyRates(body: {
  date?: string;
  rates: DailyRateRow[];
  organizationIds: string[];
  note?: string;
}): Promise<SendDailyRatesResult> {
  const { data } = await moneefloApi.post<SendDailyRatesResult>(
    "/daily-rates/send",
    body,
  );
  return data;
}
